import { ModalRef } from "mis-design-system/mis-modal";
import { MODAL_DATA_VAR } from "mis-design-system/mis-modal";
import { Component, Inject, OnInit, Optional } from "@angular/core";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { parseZone } from "moment";

@Component({
  selector: "mis-employee-web-exp-parking-disclaimer",
  templateUrl: "./parking-disclaimer.component.html",
  styleUrls: ["./parking-disclaimer.component.scss"]
})
export class ParkingDisclaimerComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  data;
  displayTexts;
  constructor(@Optional() private modalref: ModalRef, @Inject(MODAL_DATA_VAR) data) {
    this.data = data.data;
    this.displayTexts = this.data.configs.flattenedSettings.bookingDisclaimers.parking;
  }

  ngOnInit(): void {}

  cancel(): void {
    this.modalref.close();
  }

  confirm(): void {
    this.modalref.close(true);
  }
}
